import Vue from 'vue'
import NProgress from 'nprogress'
import ElementUI from 'element-ui'
import MBox from './components/box'
import App from './App.vue'
import router from './router'
import store from './store'
import apis from './api'
import Cookie from 'js-cookie'
import './assets/main.less'
import 'nprogress/nprogress.css'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)
Vue.use(MBox)

Vue.prototype.$http = apis
Vue.prototype.$cookie = Cookie
const txvLogin = window.txvLogin

// status < 500 不会抛错误
apis.axios.defaults.validateStatus = status => {
  if (status === 401) {
    app && app.$message.warning('登录过时，请重新登录！')
    router && router.push('/auth')
    return
  }
  return status < 500
}

function authExpire () {
  const hasVerifyCode = Cookie.get('verify_phone_code')
  const verifyTime = Cookie.get('verify_phone_code_time') || 0
  const diffTime = Math.abs(verifyTime - new Date().getTime())

  // 未验证手机或过期（2小时有效）
  return +hasVerifyCode !== 1 || !verifyTime || diffTime > 2 * 60 * 60 * 1000
}

router.beforeEach((to, form, next) => {
  NProgress.start()
  // 访问首页，登陆未失效跳转到 /admin
  if (to.fullPath === '/' && txvLogin.isLogin() && !authExpire()) {
    NProgress.done()
    return next('/admin')
  }

  if (to.name !== 'auth') {
    // 互联未登陆
    if (txvLogin && !txvLogin.isLogin()) {
      NProgress.done()
      return next('/auth')
    }

    if (authExpire()) {
      NProgress.done()
      return next('/auth')
    }
  }

  next()
})

router.afterEach(transition => {
  NProgress.done()
})

// 互联验证
if (txvLogin) {
  try {document.domain='qq.com'} catch (err) {console.log(err)}

  txvLogin.init()

  // 登陆成功刷新
  txvLogin.addLoginCallback(function () {
    location.reload()
  })

  if (!txvLogin.isLogin()) {
    router.push('/auth')
  }
}



Vue.config.productionTip = false

const app = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

window.app = process.env.NODE_ENV !== 'production' ? app : undefined

export default app
